import { render, staticRenderFns } from "./EspondiloartritesSummary.vue?vue&type=template&id=78767991&scoped=true&"
import script from "./EspondiloartritesSummary.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78767991",
  null
  
)

export default component.exports